module.exports = __webpack_public_path__ + "img/antes_despues_323.f01ad426.png";